var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.preview)?_vm._t("preview",function(){return [_vm._v(" Preview...... ")]}):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }